module.exports = __webpack_public_path__ + "../static/img/base_meraki.2c95c063.png";